import css2 from '../../containers/TopbarContainer/Topbar/TopbarDesktop/TopbarDesktop.module.css';
import TopbarSearchForm from '../../containers/TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { withRouter } from 'react-router-dom';
import { isMainSearchTypeKeywords, isOriginInUse } from '../../util/search';
import { getSearchPageResourceLocatorStringParams } from '../../containers/SearchPage/SearchPage.shared';
import { createResourceLocatorString, matchPathname, pathByRouteName } from '../../util/routes';
import { parse, stringify } from '../../util/urlHelpers';
import React from 'react';
import classNames from 'classnames';

const SearchBox = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const { location } = props;
  const { keywords, address, origin, bounds } = parse(location.search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const topbarSearcInitialValues = () => {
    if (isMainSearchTypeKeywords(config)) {
      return { keywords };
    }

    // Only render current search if full place object is available in the URL params
    const locationFieldsPresent = isOriginInUse(config)
      ? address && origin && bounds
      : address && bounds;
    return {
      location: locationFieldsPresent
        ? {
            search: address,
            selectedPlace: { address, origin, bounds },
          }
        : null,
    };
  };
  const handleSubmit = values => {
    const { history, location } = props;
    // Read all currently active params from the URL (preserves filters, sort, etc.)
    const currentSearchParams = parse(location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });

    const topbarSearchParams = () => {
      if (isMainSearchTypeKeywords(config)) {
        return { keywords: values?.keywords };
      }
      // topbar search defaults to 'location' search
      const { search, selectedPlace } = values?.location;
      const { origin, bounds } = selectedPlace;
      const originMaybe = isOriginInUse(config) ? { origin } : {};

      return {
        ...originMaybe,
        address: search,
        bounds,
      };
    };
    const searchParams = {
      ...currentSearchParams,
      ...topbarSearchParams(),
    };

    const { routeName, pathParams } = getSearchPageResourceLocatorStringParams(
      routeConfiguration,
      location
    );

    history.push(
      createResourceLocatorString(routeName, routeConfiguration, pathParams, searchParams)
    );
  };
  const initialSearchFormValues = topbarSearcInitialValues();
  return (<TopbarSearchForm
    className={classNames(css2.searchLink)}
    desktopInputRoot={css2.topbarSearchWithLeftPadding}
    initialValues={initialSearchFormValues}
    onSubmit={handleSubmit}
    appConfig={config}
  />);
}
const SearchBoxWithRouter = withRouter(SearchBox);
export default SearchBoxWithRouter;